'use strict'

import { mapActions } from 'vuex'
import { eventBus, eventType } from '@/app/event-bus.js'
import * as types from '@/store/types.js'
import timeoutsManager from '@/app/timer/timeouts-manager'

export default {
  methods: {
    ...mapActions({
      timerTimeoutUpdate: types.TIMER.timeout.update
    }),
    setTimeoutTimer (value) {
      this.timerTimeoutUpdate({ timeout: value })
    },
    setTimeoutTimerDefault () {
      this.setTimeoutTimer(timeoutsManager.getScreenDefaultTimeout())
    },
    offTimer () {
      this.setTimeoutTimer(0)
    },
    onTimer () {
      this.setTimeoutTimerDefault()
    },
    onTimerEnded () {
      // do noting
    },
    timerEndedListener () {
      this.onTimerEnded()
    }
  },
  mounted () {
    this.setTimeoutTimerDefault()
    eventBus.subscribe(eventType.cancelModule, this.timerEndedListener)
  },
  beforeDestroy () {
    this.setTimeoutTimer(0)
    eventBus.off(eventType.cancelModule, this.timerEndedListener)
  }
}
